import TradePermitModal from 'components/modals/documentModals/TradePermitModal';
import { useMechanicalPermitV4 } from 'hooks/useDocuments';
import { useMechanicalPermit } from 'hooks/useMechanicalPermit';
import { useGetQueryParam } from 'hooks/useModal';

const MechanicalPermit = ({
  enableFetchByDocumentId = false,
}: {
  enableFetchByDocumentId?: boolean;
}) => {
  let result: any;

  if (enableFetchByDocumentId) {
    const documentId = useGetQueryParam('documentId');
    result = useMechanicalPermitV4(documentId || undefined);
  } else {
    const documentUuid = useGetQueryParam('mechanicalPermit');
    result = useMechanicalPermit(documentUuid);
  }

  return (
    <TradePermitModal
      document={result.data}
      title="Mechanical Permit"
      isLoading={result.isLoading}
    />
  );
};

export default MechanicalPermit;
